import { ServiceInstance } from "./service-instance.model";
import { SoftwareInstance } from "./software-instance.model";
import { TicketEvent } from "./ticket-event.model";
import { TicketCategory } from "./ticketCategory.model";
import { ClassOrString, Parameter, Verylys } from "./verylys";

export enum TICKET_STATUS {
    NEW = "NEW",
    WAITING = "WAITING",
    REPLIED_BY_CUSTOMER = "REPLIED_BY_CUSTOMER",
    REPLIED_BY_SUPPORT = "REPLIED_BY_SUPPORT",
    CLOSED = "CLOSED"
}

export interface Ticket extends Verylys {
    //_id: string;
    friendly_id: string;
    parameters: {
        status: Parameter<TICKET_STATUS>
        title: Parameter<string>;
    }

    ticket_category: ClassOrString<TicketCategory>;
    ticket_events: ClassOrString<TicketEvent>[];
    service_instance: ClassOrString<ServiceInstance>;
    software_instance: ClassOrString<SoftwareInstance>;
}